import store from "@/store/index"
import {RepositoryFactory} from '@/api/RepositoryFactory';

const Profiles = RepositoryFactory.get('profiles');
const LoginSignup = RepositoryFactory.get('login');

function _clearOldData(){

  store.set("ui/personal", {});
  store.set("ui/application", {});
  store.set("ui/contact", {});
  store.set("ui/referee1", {});
  store.set("ui/referee2", {});
  store.set("ui/bachelors", {});
  store.set("ui/masters", {});

  store.set("ui/cast_certificate", null);

  store.set("ui/research", []);
  store.set("ui/consulting", []);
  store.set("ui/books", []);
  store.set("ui/papers", []);
  store.set("ui/thesis", []);
  store.set("ui/awards", []);

  store.set("ui/employmentPostPhD", []);
  store.set("ui/employmentPrePhD", []);
}

async function updateStoreData(accInfo) {
  store.set("account/isAuthenticated", true)
  store.set("account/refreshToken", accInfo.refresh_token)
  store.set("account/accessToken", accInfo.access_token)     
  store.set("account/id", accInfo.user_id)
  store.set("account/emailAddress", accInfo.email)
}

const accFunctions = {

  clearOldData : function() {
    _clearOldData();
  },
  login: async function (payload) {

    try{
      
      let res = await LoginSignup.login(payload.emailAddress, payload.password);
      await updateStoreData(res.data);

      res = await Profiles.checkProfile();
      store.set("account/profileID", res.data.profileID);
    }
    catch(error) {
      
      if(error.response && error.response.data && error.response.data.api_message){
        error.message = error.response.data.api_message;
      }

      throw error;
    };
  },
  signup: async function (payload) {
    
    try{

        let res = await LoginSignup.signup(payload.emailAddress, payload.password);
        await updateStoreData(res.data);

        res = await Profiles.checkProfile();
        store.set("account/profileID", res.data.profileID);
      }
      catch(error) {

        if(error.response && error.response.data && error.response.data.api_message){
          error.message = error.response.data.api_message;
        }
  
        throw error;
      };
  },
  initReset: async function (email) {
    try{
      await LoginSignup.passwordReset(email);
    }
    catch(error) {

      if(error.response && error.response.data && error.response.data.api_message){
        error.message = error.response.data.api_message;
      }

      throw error;
    };
  },
  reset: async function (payload) {
    try{
      await LoginSignup.confirmReset(payload);
    }
    catch(error) {
      
      if(error.response && error.response.data && error.response.data.api_message){
        error.message = error.response.data.api_message;
      }

      throw error;
    };
  },
  logout: function () {
    store.commit("account/reset")
  },
  cleanData: function (payload) {
    let cleanedData = {
      errors: [],
    }

    if (payload.emailAddress) {
      cleanedData.emailAddress = payload.emailAddress
    }

    if (payload.isVerified) {
      cleanedData.isVerified = payload.isVerified
    }

    if (payload.password) {
      if (payload.password.length < 6) {
        payload.errors.push("Password does not meet length requirements")
      } else {
        cleanedData.password = payload.password
      }
    }
    return cleanedData
  },
}

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, "$accountAPI", {
      value: accFunctions,
    })
  },
}
